import styled from '@emotion/styled';

export const ImgStyled = styled.img`
  margin-left: 3rem;
  width: 12rem;
`;
